export const LOAD_FIRESTORE_DATA = "LOAD_FIRESTORE_DATA";
export const FIRESTORE_ERROR = "FIRESTORE_ERROR";
export const LOAD_FIRESTORE_DOC = "LOAD_FIRESTORE_DOC";
export const LOADING_COLLECTION = "LOADING_COLLECTION";
export const COLLECTION_LOADED = "COLLECTION_LOADED";
export const LOADING_DOC = "LOADING_DOC;";
export const DOC_LOADED = "DOC_LOADED";
export const UNLOAD_DOCS = "UNLOAD_DOCS";
export const LOAD_BRANCHES = "LOAD_BRANCHES";
export const LOAD_MANAGED_BRANCHES = "LOAD_MANAGED_BRANCHES";
